<template>
  <div class="vote container">
    <div class="top">
      <div class="back_box">
        <!-- <img src="@/assets/images/icons/icon_back.png" alt="" /> -->
        <el-button
          class="back-btn"
          type="text"
          icon="el-icon-arrow-left"
          @click="$router.go(-1)"
          >返回</el-button
        >
      </div>
      <div class="title_input">
        <el-input v-model="form.name" placeholder="请输入标题"></el-input>
        <!-- <div class="btns">
          <div
            class="one"
            :class="{ active: form.voteType == item.id }"
            v-for="item in list"
            :key="item.id"
            @click="form.voteType = item.id"
          >
            {{ item.label }}
          </div>
        </div> -->
      </div>
    </div>

    <div class="main">
      <el-form ref="form" :model="form" label-width="150px">
        <el-form-item label="选项">
          <div class="option" v-for="(i, index) in voteOptions" :key="index">
            <!-- <span class="tag">{{ String.fromCharCode(65 + index) }}</span> -->
            <el-input
              v-model="i.value"
              type="textarea"
              :autosize="{ minRows: 1 }"
              resize="none"
              placeholder="请输入选项内容"
              class="option_input"
            />
            <i
              class="el-icon-delete"
              v-if="voteOptions.length > 2"
              @click="voteOptions.splice(index, 1)"
            ></i>
          </div>
          <el-button
            icon="el-icon-plus"
            v-show="voteOptions.length < 10"
            @click="voteOptions.push({ value: '' })"
            size="small"
            style="margin-top: 10px"
            >添加选项</el-button
          >
        </el-form-item>
        <!-- <el-form-item label="允许参与者查看统计">
          <el-switch v-model="form.lookStatistics"></el-switch>
        </el-form-item> -->
        <el-form-item label="匿名投票">
          <el-switch v-model="form.anonymous"></el-switch>
        </el-form-item>
        <el-form-item label="自动结束">
          <el-switch v-model="form.autoStop"></el-switch>
        </el-form-item>
        <el-form-item label="活动时长" v-show="form.autoStop">
          <el-input-number
            size="mini"
            v-model="day"
            :controls="false"
            :min="0"
            :max="29"
          ></el-input-number
          ><span style="margin: 0 20px">天</span>
          <el-input-number
            size="mini"
            v-model="hour"
            :controls="false"
            :min="0"
            :max="23"
          ></el-input-number
          ><span style="margin: 0 20px">小时</span>
          <el-input-number
            size="mini"
            v-model="minute"
            :controls="false"
            :min="0"
            :max="59"
          ></el-input-number
          ><span style="margin: 0 20px">分钟</span>
        </el-form-item>
        <el-form-item class="btn_row">
          <el-button
            type="primary"
            @click="handleSave(true)"
            style="margin-right: 50px"
            >立即开始</el-button
          >
          <el-button @click="handleSave(false)">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import mixinsData from "../mixins";

export default {
  name: "vote",
  mixins: [mixinsData],
  data() {
    return {
      form: {
        classChapterId: null,
        classId: null,
        name: "",
        autoStop: true,
        lookStatistics: false,
        anonymous: false,
        type: "VOTE",
        duration: null,
        status: "PEND",
      },
      voteOptions: [
        {
          value: "",
        },
        {
          value: "",
        },
      ],
      day: 0,
      hour: 0,
      minute: 30,
      // list: [
      //   { id: "AGREE_OPPOSE", label: "赞同/反对" },
      //   { id: "RIGHT_ERROR", label: "正确/错误" },
      //   { id: "A_B", label: "选A/选B" },
      //   { id: "A_B_C_D", label: "选A/选B/选C/选D" },
      // ],
    };
  },
  deactivated() {
    this.form = this.$options.data().form;
    this.day = this.$options.data().day;
    this.hour = this.$options.data().hour;
    this.minute = this.$options.data().minute;
    this.voteOptions = this.$options.data().voteOptions;
  },
  computed: {
    duration() {
      return this.day * 24 * 60 + this.hour * 60 + this.minute;
    },
  },
  watch: {
    "form.voteOptions"(val) {
      if (val) {
        this.voteOptions = JSON.parse(val).map((value) => ({ value }));
      }
    },
  },
  methods: {
    handleSave(start) {
      this.form.classChapterId = this.$route.query.classChapterId;
      this.form.classId = this.$route.query.id;
      if (start) this.form.status = "STARTED";
      else this.form.status = "PEND";
      this.form.duration = this.duration;
      this.form.voteOptions = JSON.stringify(
        this.voteOptions.map((item) => item.value)
      );
      if (this.$route.query.activityId) {
        // 修改
        this.form.activityId = this.$route.query.activityId;
        this.handleEdit(this.form);
      } else {
        // 新增
        this.handleAdd(this.form);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.vote {
  height: 100%;
  .top {
    margin-top: 30px;
    margin-bottom: 20px;
    width: 100%;
    text-align: left;
    .back_box {
      display: inline-block;
      width: calc(100% - 1126px);
      text-align: center;
      vertical-align: middle;
      cursor: pointer;
      img {
        width: 44px;
      }
      p {
        color: #969696;
        font-size: 16px;
      }
    }
    .title_input {
      display: inline-block;
      padding: 24px 30px;
      background-color: #fff;
      width: 1126px;
      vertical-align: middle;
    }
    .btns {
      margin-top: 20px;
      .one {
        display: inline-block;
        margin-right: 20px;
        width: 160px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #a8a8b3;
        border: 1px solid #e1e1e5;
        border-radius: 4px;
        font-size: 16px;
        cursor: pointer;
        &.active {
          color: #fff;
          border-color: #1890ff;
          background: #1890ff;
        }
      }
    }
  }
  .main {
    padding: 60px 280px;
    height: calc(100% - 30px - 20px - 148px - 30px);
    background-color: #fff;
    text-align: left;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 4px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }

    .el-input-number {
      width: 60px;
    }

    ::v-deep .btn_row {
      margin-top: 60px;
      text-align: center;
      .el-form-item__content {
        margin-left: 0 !important;
      }
    }

    .option {
      margin-bottom: 10px;

      .tag {
        display: inline-block;
        width: 38px;
        text-align: center;
        line-height: 38px;
        height: 38px;
        border-radius: 50%;
        border: 1px solid #e6e6e6;
        cursor: pointer;
      }

      ::v-deep .option_input {
        margin-left: 10px;
        width: 80%;
        vertical-align: middle;
        .el-textarea__inner {
          font-family: inherit;
        }
      }

      .el-icon-delete {
        margin-left: 10px;
        font-size: 20px;
        color: #f56c6c;
        vertical-align: middle;
        cursor: pointer;
      }
    }
  }
}
</style>